var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsaSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3496 14.999H30.0018C30.0018 13.6451 29.8213 12.3336 29.485 11.0859H14.3496V14.999Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3496 7.17479H27.8002C26.8819 5.67643 25.7079 4.35203 24.339 3.26172H14.3496V7.17479Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0013 29.9991C18.5315 29.9991 21.7763 28.779 24.3386 26.7383H5.66406C8.22637 28.779 11.4711 29.9991 15.0013 29.9991Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.20244 22.8271H27.7992C28.5364 21.6243 29.1081 20.3094 29.4841 18.9141H0.517578C0.893574 20.3094 1.46527 21.6243 2.20244 22.8271Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.94828 2.34246H8.31521L7.04373 3.26619L7.52941 4.76086L6.25799 3.83713L4.98656 4.76086L5.40609 3.46963C4.2866 4.40215 3.30539 5.49469 2.4968 6.71203H2.93479L2.12543 7.30002C1.99934 7.51037 1.8784 7.72406 1.7625 7.94092L2.14898 9.13043L1.42793 8.60654C1.24869 8.98629 1.08475 9.37459 0.937383 9.77098L1.36318 11.0816H2.93479L1.6633 12.0053L2.14898 13.5L0.877559 12.5763L0.115957 13.1296C0.0397266 13.7424 0 14.3665 0 15H15C15 6.71578 15 5.73914 15 0C12.0368 0 9.27451 0.85957 6.94828 2.34246ZM7.52941 13.5L6.25799 12.5763L4.98656 13.5L5.47225 12.0053L4.20076 11.0816H5.77236L6.25799 9.58693L6.74361 11.0816H8.31521L7.04373 12.0053L7.52941 13.5ZM7.04373 7.63576L7.52941 9.13043L6.25799 8.2067L4.98656 9.13043L5.47225 7.63576L4.20076 6.71203H5.77236L6.25799 5.21736L6.74361 6.71203H8.31521L7.04373 7.63576ZM12.9098 13.5L11.6384 12.5763L10.367 13.5L10.8527 12.0053L9.58119 11.0816H11.1528L11.6384 9.58693L12.124 11.0816H13.6956L12.4242 12.0053L12.9098 13.5ZM12.4242 7.63576L12.9098 9.13043L11.6384 8.2067L10.367 9.13043L10.8527 7.63576L9.58119 6.71203H11.1528L11.6384 5.21736L12.124 6.71203H13.6956L12.4242 7.63576ZM12.4242 3.26619L12.9098 4.76086L11.6384 3.83713L10.367 4.76086L10.8527 3.26619L9.58119 2.34246H11.1528L11.6384 0.847793L12.124 2.34246H13.6956L12.4242 3.26619Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsaSvg);
export default __webpack_public_path__ + "static/media/usa_svg.c5b46470707536433379febcd067508d.svg";
export { ForwardRef as ReactComponent };